import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Delete preference
 * */
export function* deletePreference(data) {
    const response = yield call(api.deletePreference, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Success deleted',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        yield put({
            type: actionTypes.DELETE_PREFERENCE.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: 'Error deleted',
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });

    yield put({
        type: actionTypes.DELETE_PREFERENCE.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchDeletePreference() {
    while (true) {
        const { data } = yield take(actionTypes.DELETE_PREFERENCE.REQUEST);
        yield fork(deletePreference, data);
    }
}

/**
 * Get preference
 * */
export function* getPreference(data) {
    const response = yield call(api.getPreference, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_PREFERENCE.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_PREFERENCE.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetPreference() {
    while (true) {
        const { data } = yield take(actionTypes.GET_PREFERENCE.REQUEST);
        yield fork(getPreference, data);
    }
}

/**
 * Get preference
 * */
export function* getPreferences(data) {
    const response = yield call(api.getPreferences, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_PREFERENCES.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_PREFERENCES.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetPreferences() {
    while (true) {
        const { data } = yield take(actionTypes.GET_PREFERENCES.REQUEST);
        yield fork(getPreferences, data);
    }
}

/**
 * Update preference
 * */
export function* updatePreference(data, _id) {
    const response = yield call(api.updatePreference, data, _id);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Preference updated',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        yield put({
            type: actionTypes.UPDATE_PREFERENCE.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: 'Preference didn`t update',
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });

    yield put({
        type: actionTypes.UPDATE_PREFERENCE.FAILURE,
    });

    return response;
}

export function* watchUpdatePreferences() {
    while (true) {
        const { data, _id } = yield take(actionTypes.UPDATE_PREFERENCE.REQUEST);
        yield fork(updatePreference, data, _id);
    }
}

/**
 * Update preference meta
 * */
export function* updatePreferenceMeta(data) {
    const response = yield call(api.updatePreferenceMeta, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_PREFERENCE_META.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.UPDATE_PREFERENCE_META.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchUpdatePreferencesMeta() {
    while (true) {
        const { data } = yield take(actionTypes.UPDATE_PREFERENCE_META.REQUEST);
        yield fork(updatePreferenceMeta, data);
    }
}

export default [
    watchDeletePreference,
    watchGetPreference,
    watchGetPreferences,
    watchUpdatePreferences,
    watchUpdatePreferencesMeta,
];



// WEBPACK FOOTER //
// ./app/sagas/preferences/index.js